<template>
    <v-text-field
        :loading="loading"
        ref="inputRef"
        :disabled="readonly"
        :height="height"
        :suffix="suffix"
        :color="color"
        :rules="rules"
        :label="label"
        validate-on-blur
        @blur="onBlur()"
        @focus="$emit('focus')"
        outlined
    ></v-text-field>
</template>

<script setup>
import { useCurrencyInput } from 'vue-currency-input'
import { watch, toRef } from '@vue/composition-api'
import { watchDebounced } from '@vueuse/core'

export default {
  name: 'SumInput',
  props: {
    modelValue: Number, // Vue 2: value
    options: Object,
    label: String,
    id: String,
    color: String,
    loading: Boolean,
    readonly: Boolean,
    height: Number,
    suffix: String,
    rules: Array,
    sumValue: String
  },
  setup (props, { emit }) {
    const { inputRef, numberValue, setValue } = useCurrencyInput(props.options)
    const sumValue = toRef(props, 'sumValue');

    watch(inputRef, (newValue) => {
      const numberFormat = props.sumValue.replace(',', '.');
      if (newValue && (!isNaN(+numberFormat) && +numberFormat > 0)) {
        setValue(+numberFormat);
      }
    });

    watch(sumValue, (newValue) => {
      const numberFormat = newValue.replace(',', '.');
      if (newValue && !isNaN(+numberFormat)) {
        setValue(+numberFormat);
      }
    });

    watchDebounced(numberValue, (value) => emit('update:modelValue', value), { debounce: 1000 })

    return { inputRef }
  },
  methods: {
    onBlur() {
        this.$emit("change", this.inputRef._data.lazyValue);
        this.$emit('blur');
    }
  }
}
</script>